import { useContext, useEffect, useRef } from "react";
import { RightDrawerContext } from "../context/RightDrawerContext";

const useOutsideClick = () => {
  const { closeDrawer } = useContext(RightDrawerContext);
  const refOne = useRef<HTMLElement>(null);
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      const dialogElement = document.querySelector(".MuiDialog-root");
      const target = e.target as HTMLElement;
      if (
        refOne.current &&
        !refOne.current.contains(target) &&
        target.id !== "document-media-viewer-close-icon" &&
        target.parentNode &&
        (target.parentNode as HTMLElement).id !==
          "document-media-viewer-close-icon" &&
        target.id !== "document-media-viewer-close-button" &&
        !dialogElement?.closest(".MuiDialog-root")
      ) {
        closeDrawer();
      }
    };

    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, [closeDrawer]);

  return refOne;
};

export { useOutsideClick };
